import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { supportFeedbackBackend } from './support-feedback.backend';
import { supportFeedbackReducer } from './support-feedback.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('supportFeedback', supportFeedbackReducer),
    BackendModule.forFeature('supportFeedback', supportFeedbackBackend),
  ],
})
export class DatastoreSupportFeedbackModule {}
